import { Wrench, Minus, Plus, Banknote, CreditCard, CircleDollarSign, Loader2, CheckCircle2, Printer } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

// Cobro directo de servicio (Baños/Lavado, etc.) — presentacional.
export const CobroServicioDialog = ({
  servicioCobro, servReceipt, cerrarCobroServicio,
  servCant, setServCant, servMetodo, setServMetodo, servTotal, confirmarCobroServicio, servPaying,
  imprimirComprobanteServicio,
}) => (
  <Dialog open={!!servicioCobro} onOpenChange={(v) => { if (!v) cerrarCobroServicio(); }}>
    <DialogContent className="rounded-none border-[#FFCC00]/60 bg-[#0A0A0A] text-white sm:max-w-md max-h-[90dvh] overflow-y-auto overflow-x-hidden" data-testid="cobro-servicio-modal">
      {!servReceipt ? (
        <>
          <DialogHeader>
            <DialogTitle className="font-display font-black text-white flex items-center gap-2">
              <Wrench className="h-5 w-5 text-[#FFCC00]" /> Cobro directo · {servicioCobro?.nombre}
            </DialogTitle>
            <DialogDescription className="text-white/60">
              Cobro inmediato del servicio. El ingreso se sumará a la caja del turno activo.
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-4">
            <div className="flex items-center justify-between border border-white/15 bg-white/5 p-3">
              <span className="text-sm text-white/70">Precio unitario</span>
              <span className="font-display font-black text-lg text-white" data-testid="serv-precio-unitario">${Number(servicioCobro?.precio || 0).toFixed(2)}</span>
            </div>

            <div>
              <label className="text-[10px] tracking-[0.15em] uppercase font-bold text-white/60">Cantidad</label>
              <div className="flex items-center gap-3 mt-2">
                <button onClick={() => setServCant((c) => Math.max(1, c - 1))} data-testid="serv-cant-menos"
                  className="btn-hard h-11 w-11 bg-white/5 border border-white/20 hover:border-[#FFCC00] flex items-center justify-center"><Minus className="h-5 w-5" /></button>
                <span className="font-display font-black text-2xl w-12 text-center" data-testid="serv-cant">{servCant}</span>
                <button onClick={() => setServCant((c) => c + 1)} data-testid="serv-cant-mas"
                  className="btn-hard h-11 w-11 bg-white/5 border border-white/20 hover:border-[#FFCC00] flex items-center justify-center"><Plus className="h-5 w-5" /></button>
              </div>
            </div>

            <div>
              <label className="text-[10px] tracking-[0.15em] uppercase font-bold text-white/60">Método de pago</label>
              <div className="grid grid-cols-2 gap-3 mt-2">
                <button onClick={() => setServMetodo("Efectivo")} data-testid="serv-metodo-efectivo"
                  className={`btn-hard h-12 border flex items-center justify-center gap-2 font-bold uppercase tracking-wider text-sm ${servMetodo === "Efectivo" ? "bg-[#10B981]/15 border-[#10B981] text-[#10B981]" : "bg-white/5 border-white/20 text-white/70"}`}>
                  <Banknote className="h-5 w-5" /> Efectivo
                </button>
                <button onClick={() => setServMetodo("Tarjeta")} data-testid="serv-metodo-tarjeta"
                  className={`btn-hard h-12 border flex items-center justify-center gap-2 font-bold uppercase tracking-wider text-sm ${servMetodo === "Tarjeta" ? "bg-[#3B82F6]/15 border-[#3B82F6] text-[#3B82F6]" : "bg-white/5 border-white/20 text-white/70"}`}>
                  <CreditCard className="h-5 w-5" /> Tarjeta
                </button>
              </div>
            </div>

            <div className="flex items-center justify-between border-2 border-[#FFCC00]/60 bg-[#FFCC00]/5 p-3">
              <span className="text-sm font-bold uppercase tracking-wider text-[#FFCC00]">Total</span>
              <span className="font-display font-black text-2xl text-[#FFCC00]" data-testid="serv-total">${servTotal.toFixed(2)}</span>
            </div>

            <button onClick={confirmarCobroServicio} disabled={servPaying} data-testid="serv-confirmar-btn"
              className="btn-hard w-full h-14 bg-[#FFCC00] text-[#0A0A0A] border border-[#FFCC00] font-black uppercase tracking-wider flex items-center justify-center gap-2 disabled:opacity-60">
              {servPaying ? <Loader2 className="h-6 w-6 animate-spin" /> : <><CircleDollarSign className="h-6 w-6" /> Cobrar servicio</>}
            </button>
          </div>
        </>
      ) : (
        <>
          <DialogHeader>
            <DialogTitle className="font-display font-black text-[#10B981] flex items-center gap-2">
              <CheckCircle2 className="h-6 w-6" /> Cobro registrado
            </DialogTitle>
            <DialogDescription className="text-white/60">
              {servReceipt.nombre} · {servReceipt.cantidad} × ${servReceipt.precio.toFixed(2)} · {servReceipt.metodo}
            </DialogDescription>
          </DialogHeader>
          <div className="flex items-center justify-between border-2 border-[#10B981]/50 bg-[#10B981]/10 p-4">
            <span className="text-sm font-bold uppercase tracking-wider text-[#10B981]">Total cobrado</span>
            <span className="font-display font-black text-3xl text-[#10B981]" data-testid="serv-receipt-total">${servReceipt.total.toFixed(2)}</span>
          </div>
          <div className="grid grid-cols-2 gap-3 mt-2">
            <button onClick={imprimirComprobanteServicio} data-testid="serv-imprimir-btn"
              className="btn-hard h-12 bg-white/5 border border-white/20 hover:border-[#FFCC00] flex items-center justify-center gap-2 font-bold uppercase tracking-wider text-sm">
              <Printer className="h-5 w-5" /> Imprimir
            </button>
            <button onClick={cerrarCobroServicio} data-testid="serv-cerrar-btn"
              className="btn-hard h-12 bg-[#FFCC00] text-[#0A0A0A] border border-[#FFCC00] flex items-center justify-center gap-2 font-black uppercase tracking-wider text-sm">
              <CheckCircle2 className="h-5 w-5" /> Listo
            </button>
          </div>
        </>
      )}
    </DialogContent>
  </Dialog>
);

export default CobroServicioDialog;
